import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import Counter from "./Counter";

const stats = [
  { value: 500, suffix: "+", label: "Agents Partnered" },
  { value: 12000, suffix: "+", label: "Calls Monthly" },
  { value: 98, suffix: "%", label: "Client Retention" },
  { value: 5, suffix: "yrs", label: "Industry Experience" },
];

export default function StatsBar() {
  return (
    <Box bg="brand.coral" py={7} px={{ base: 6, md: 12, lg: 20 }}>
      <SimpleGrid
        columns={{ base: 2, md: 4 }}
        maxW="1400px"
        mx="auto"
      >
        {stats.map((s, i) => (
          <Box
            key={i}
            textAlign="center"
            borderRight={
              i < 3
                ? { base: i === 1 ? "none" : "1px solid rgba(255,255,255,0.2)", md: "1px solid rgba(255,255,255,0.2)" }
                : "none"
            }
            py={3}
          >
            <Text
              fontFamily="'Playfair Display', serif"
              fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
              fontWeight="700"
              color="white"
              lineHeight="1"
              mb={1}
            >
              <Counter to={s.value} suffix={s.suffix} />
            </Text>
            <Text
              fontSize={{ base: "9px", md: "xs" }}
              letterSpacing="0.15em"
              textTransform="uppercase"
              color="rgba(255,255,255,0.75)"
            >
              {s.label}
            </Text>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
}
